var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 22.8143,
    height: 22.8143,
    rx: 11.4071,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 22.8143,
    height: 22.8143,
    rx: 11.4071,
    stroke: "white",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3483 16.5124C10.0956 16.5124 9.8555 16.4148 9.67861 16.244L6.10293 12.792C5.73652 12.4383 5.73652 11.8528 6.10293 11.499C6.46935 11.1453 7.07582 11.1453 7.44223 11.499L10.3483 14.3046L16.8426 8.03484C17.209 7.6811 17.8155 7.6811 18.1819 8.03484C18.5483 8.38858 18.5483 8.97407 18.1819 9.32781L11.0179 16.244C10.841 16.4148 10.601 16.5124 10.3483 16.5124Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaved);
export default __webpack_public_path__ + "static/media/saved.6781fc071fa6e8085407754776d051e6.svg";
export { ForwardRef as ReactComponent };